import React, { FunctionComponent } from "react";
import HeaderMobileBottomTapBar from "@Components/molecules/header/HeaderMobileBottomTapBar";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import { Category, HeaderMenuLink } from "@Types/header";
import HeaderCategoryItem from "./HeaderCategoryItem";
import "./style.scss";

interface Props {
  accountLinks: HeaderMenuLink[];
  cartArticlesLength: number;
  categories: Category[] | undefined;
  draftsNumber: number;
}

const HeaderCategories: FunctionComponent<Props> = ({
  accountLinks,
  cartArticlesLength,
  categories,
  draftsNumber,
}) => {
  const { isMediumScreen } = useBreakpoint();

  const featuredCategories =
    categories &&
    categories.filter((category) => category.featured).sort((a, b) => a.priority - b.priority);
  const notFeaturedCategories =
    categories &&
    categories.filter((category) => !category.featured).sort((a, b) => a.priority - b.priority);

  return (
    <>
      {notFeaturedCategories ? (
        isMediumScreen ? (
          <HeaderMobileBottomTapBar
            accountLinks={accountLinks}
            cartArticlesLength={cartArticlesLength}
            categories={notFeaturedCategories}
            draftsNumber={draftsNumber}
            featuredCategories={featuredCategories}
          />
        ) : (
          <div className="HeaderCategories">
            {notFeaturedCategories.map((category: Category) => {
              return <HeaderCategoryItem category={category} key={category.tag} />;
            })}
            {featuredCategories && featuredCategories.length > 0 && (
              <div className="HeaderCategories-separator-wrapper">
                <div className="HeaderCategories-separator" />
              </div>
            )}
            {featuredCategories &&
              featuredCategories.map((category: Category) => (
                <HeaderCategoryItem category={category} key={category.tag} />
              ))}
          </div>
        )
      ) : null}
    </>
  );
};

export default HeaderCategories;
